export default {
  title: 'Gender',
  male: 'Male',
  female: 'Female',
  undetermined: 'Undetermined',
};
